import React from 'react'
//import DocTagSelector from './DocTagSelector'
import withView from '../cmn/docAutomation/withView';
import FormInput from '../../library/form/components/FormInput';
import FormTag from "../../library/form/components/FormTag";
import FormTitle from "../../library/form/components/FormTitle";
import { UiView, UiViewHeading, UiTitle, UiViewContent } from "../../library/layout/Index";
import SarasChipContainer from '../../library/repeater/list/SarasChipContainer';

const DocShare = (props) => {
    const { formObject, viewData } = props;

    if (!viewData)
        return (null)

    // console.log("allocation viewdata", formObject);

    const canManageShare = formObject.dataList.canManageShare === '1' ? 1 : 0;
    //const canManageShare = formObject.datalist.canManagaeShare;

    // console.log("allocation viewdata canManageShare", canManageShare);

    const renderFormInput = () => {
        if(canManageShare)
        {
            return(
                <div className="">
                    <FormInput formObject={formObject} rowKey="" headerKey="shareHeader" className="uiInput uiTagInput" alwaysRender={true} placeholder="Select..."
                        action={{ InputType: "ac", paramName: "shareProfile", actionId: 'save', acMethod: "UserNamesByRole", acDepCtrl: { role: "%dataList.roleId" }, actionParam: { "updatetag": "1"}, refreshMode:"self" }}
                    />
                </div>
            )
        }
    }


    return (
        <UiView>
            <UiViewHeading>
                <UiTitle>
                    <FormTitle formObject={formObject} value='Assign Owner' />
                </UiTitle>
            </UiViewHeading>
            <UiViewContent>
                    <div className="">
                        <div className="uiFlexBox3">
                            {renderFormInput()}
                            <div className="uiSelectedChip">
                                <SarasChipContainer>
                                    {
                                        Object.values(viewData).map((row, index) => (
                                            <FormTag formObject={formObject} rowKey={row.rowKey} disableDelete={!canManageShare} 
                                                action={{ paramName: "tag", actionParam:{ "updatetag": "1" },refreshMode:"self" }}
                                            />
                                        ))
                                    }
                                </SarasChipContainer>
                            </div>
                        </div>
                    </div>
            </UiViewContent>
        </UiView>
    )
}

export default withView(DocShare, "docShare", "docShare,v5WorkFlow");
